/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import { AppServiceSyncMachineConfig } from '../../state-machine';
import {
  triggerTotalSales,
  triggerProvisionalPoliciesCount,
  triggerActualPoliciesCount,
  triggerSalesValue,
  triggerRegionStats,
  triggerRegionStatsPeriodicity,
  triggerTotalGrantSum,
  triggerConsumedGrantSum,
  triggerConsumedPoliciesCount,
} from './states';
import uuid from 'react-uuid';

export const ANALYTICS_RESULT_FORMATTER_CONFIG: AppServiceSyncMachineConfig = {
  init: 'START',
  transitions: [
    {
      name: 'triggerTotalSales',
      from: 'START',
      to: 'TOTAL_SALES',
    },
    {
      name: 'triggerConsumedPoliciesCount',
      from: 'TOTAL_SALES',
      to: 'ACTUAL_POLICIES_COUNT',
    },
    {
      name: 'triggerSalesValue',
      from: 'ACTUAL_POLICIES_COUNT',
      to: 'SALES_VALUE',
    },
    {
      name: 'triggerEnd',
      from: 'SALES_VALUE',
      to: 'END',
    },
  ],
  methods: {
    onTriggerTotalSales: triggerTotalSales,
    onTriggerConsumedPoliciesCount: triggerConsumedPoliciesCount,
    onTriggerSalesValue: triggerSalesValue,
  },
};
